// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Sr_ig","col":"styles_col__1kWM2"};